var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('banner'),_c('about-section',{attrs:{"show":true}}),_c('resume-section'),_c('skill-section'),_c('portfolio-section'),_c('service-section'),_c('testimonial-section'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }